// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /notification-settings/get-global.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeNotificationSettingsGetGlobalBody,
  typeNotificationSettingsGetGlobalOutput200,
} from "../../sdk/notificationSettings/postNotificationSettingsGetGlobal";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildNotificationSettingsGetGlobalQueryKey(
  payload: typeNotificationSettingsGetGlobalBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:notificationSettings:notificationSettingsGetGlobal",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeNotificationSettingsGetGlobalOutput200,
    unknown,
    typeNotificationSettingsGetGlobalOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useNotificationSettingsGetGlobal(
  payload: typeNotificationSettingsGetGlobalBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildNotificationSettingsGetGlobalQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postNotificationSettingsGetGlobal(payload),
    ...resolvedOptions,
  });
}
